"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageCount = void 0;
var react_1 = __importStar(require("react"));
var PulseTable_1 = __importDefault(require("./PulseTable"));
var react_paginate_1 = __importDefault(require("react-paginate"));
var PaginationIcon_1 = __importStar(require("./PaginationIcon"));
// eslint-disable-next-line @typescript-eslint/ban-types
function PulseTableWithLocalPagination(props) {
    var _a = (0, react_1.useState)([]), items = _a[0], setItems = _a[1];
    var _b = (0, react_1.useState)(1), pageCount = _b[0], setPageCount = _b[1];
    var _c = (0, react_1.useState)(0), pageNumber = _c[0], setPageNumber = _c[1];
    var _d = (0, react_1.useState)(0), itemOffset = _d[0], setItemOffset = _d[1];
    // Set page number and updates the request for the audit list
    var changePage = function (data) {
        var selected = data.selected !== undefined ? data.selected : data;
        setPageNumber(selected);
        var newOffset = (+selected * props.resultsPerPage) % props.items.length;
        setItemOffset(newOffset);
    };
    (0, react_1.useEffect)(function () {
        var endOffset = itemOffset + props.resultsPerPage;
        setPageCount(getPageCount(props.items.length, props.resultsPerPage));
        setItems(props.items.slice(itemOffset, endOffset));
    }, [itemOffset, props]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PulseTable_1.default, { items: items, headers: props.headers, noItemsSection: props.noItemsSection, customRenderers: props.customRenderers }),
        props.items.length > 0 && (react_1.default.createElement("div", { className: "pagination-wrapper" },
            react_1.default.createElement(react_paginate_1.default, { pageCount: pageCount, pageRangeDisplayed: 5, marginPagesDisplayed: 1, containerClassName: "pagination", activeClassName: "active-page", onPageChange: changePage, forcePage: pageNumber, previousLabel: react_1.default.createElement(PaginationIcon_1.default, { rootElement: "Span", rootElementClassName: "d-grid", className: "nav-links next-previous-icon", icon: PaginationIcon_1.IconType.Previous, size: "Small" }), nextLabel: react_1.default.createElement(PaginationIcon_1.default, { rootElement: "Span", rootElementClassName: "d-grid", className: "next-previous-icon", icon: PaginationIcon_1.IconType.Next, size: "Small" }), pageClassName: "other-pages", breakClassName: "other-pages", nextClassName: "next-page", previousClassName: "previous-page", pageLinkClassName: "pagination-link", activeLinkClassName: "active-pagination-link" })))));
}
exports.default = PulseTableWithLocalPagination;
function getPageCount(totalResults, numberPerPage) {
    var total = Math.ceil(totalResults / numberPerPage);
    return isNaN(total) ? 1 : total;
}
exports.getPageCount = getPageCount;
